import {Spinner} from 'quickstart/components/layout/Spinner'
import {MetaHeadline} from 'quickstart/components/tizra/MetaHeadline'
import {logger, meta} from 'tizra'
import type {BrowseGalleryProps} from '..'

const log = logger('BrowseGallery/tiles')

/**
 * Left side of a Headline block.
 */
export const HeadlineGallery = ({
  search: {lastResults, isFetching},
  slots,
}: BrowseGalleryProps) => (
  <div style={{minHeight: '100px', position: 'relative'}}>
    {lastResults?.slice(0, 1)?.map(r => (
      <MetaHeadline key={meta.key(r)} metaObj={r} slots={slots} />
    ))}
    {isFetching && <Spinner />}
  </div>
)
